import { render, staticRenderFns } from "./ExtensionPopup.vue?vue&type=template&id=04c1e298&scoped=true&"
import script from "./ExtensionPopup.vue?vue&type=script&lang=js&"
export * from "./ExtensionPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionPopup.vue?vue&type=style&index=0&id=04c1e298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1e298",
  null
  
)

export default component.exports